import React, { useRef } from 'react';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import { CNavLink } from "./c/CHeader";
import './Header.scss';
import '../../../styles/_pages.scss';
import ReactImageFallback from "react-image-fallback";
import BottomMenuList from './BottomMenuList';
import TopMenuList from "./TopMenuList";
import MobileMenuList from "./MobileMenuList";
import LanguageSwitcher from "./LanguageSwitcher";
import userDefaultImage from './../../../assets/images/user.svg';
import { useSelector } from "react-redux";
import { useTranslations, useScreenWidth } from "examsbook-react-sdk/custom-hooks";
import useOnClickOutside from "../../../hooks/useClickOutside";
import { useIsPremiumUser } from "examsbook-react-sdk/custom-hooks";
import { useNavigate } from "react-router-dom";

/**
 * Main drawer component.
 * @param props
 * @returns {*}
 * @constructor
 */
function CDrawer(props) {
    const { classes, open, handleDrawerClose, openFeedbackModel } = props;
    const ref = useRef();
    useOnClickOutside(ref, () => {
        if (screenWidth && screenWidth < 800) {
            handleDrawerClose();
        }
    });
    const t = useTranslations();
    const user = useSelector(state => state.user);
    const lng = useSelector(state => state.lng);
    const screenWidth = useScreenWidth();
    let imageUrl;
    if (user.image) {
        imageUrl = user.image.thumbnail.webP;
    }
    const navigate = useNavigate();
    const isPremium = useIsPremiumUser();
    const currentDate = new Date().toISOString();
    const expieryDate = user.premiumExpiry;
    const diff = Math.floor((Date.parse(expieryDate) - Date.parse(currentDate)) / 86400000);
    const appSettings = useSelector((state) => state.appSettings);
    const isPaymentEnabled = !!appSettings.paymentEnabled;
    return (
        <Drawer className={`drawer-mobile`}
                variant="permanent"
                classes={{
                    paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
                }}
                open={open}>
            <div className={classes.drawerHeader}>
                <IconButton className="display-none" onClick={handleDrawerClose}>
                    <ChevronLeftIcon/>
                </IconButton>
                <div className="drawer-close" onClick={handleDrawerClose}>
                    <i className="fa fa-times"/>
                </div>
                <ReactImageFallback
                    src={imageUrl}
                    fallbackImage={userDefaultImage}
                    initialImage={userDefaultImage}
                    alt="user image"
                    className="my-image main-logo"/>
            </div>
            <div className="user-section">
                <h4>{user.name}</h4>
                {
                    isPaymentEnabled && <h4 className="sidebar-vip-btn">{isPremium && (diff <= 7) ?
                        <Button className="renew-plan" onClick={() => {
                            if (screenWidth && screenWidth < 800) {
                                handleDrawerClose();
                            }
                            ;navigate('/my-app/payments');
                        }}>{t('RENEW_VIP')}</Button>
                        : isPremium ? <Button className="header-plan"
                                              onClick={() => screenWidth && screenWidth < 800 ? handleDrawerClose : () => null}>{t('VIP')}</Button>
                            : <Button className="header-become-plan" onClick={() => {
                                if (screenWidth && screenWidth < 800) {
                                    handleDrawerClose();
                                }
                                navigate('/my-app/payments');
                            }}>{t('GET_VIP')}</Button>
                    }</h4>
                }

                <CNavLink to="/my-app/settings">
                    <i className="fa fa-pencil"
                       onClick={screenWidth && screenWidth < 800 ? handleDrawerClose : () => null}/>
                </CNavLink>
                <div className="notification-bar">
                    <ul className="right-menus">
                        <li className="removeText">
                            <LanguageSwitcher/>
                        </li>
                    </ul>
                </div>
            </div>
            <List className="listing">
                <TopMenuList openDrawerStatus={open} t={t} screenWidth={screenWidth}
                             handleDrawerClose={handleDrawerClose}/>
                <div className="bottom-listing">
                    <BottomMenuList t={t} openDrawerStatus={open} lang={lng}/>
                </div>
                <div className="mobile-menu-list">
                    <MobileMenuList t={t} openDrawerStatus={open} screenWidth={screenWidth}
                                    handleDrawerClose={handleDrawerClose} openFeedbackModel={openFeedbackModel}/>
                </div>
            </List>
        </Drawer>
    );
}

export default CDrawer;
